import { useEffect, useState } from "react";
import { getAdmins, createAdmin, deleteAdmin } from "../services/admin.service";
import AdminHeader from "../components/admin/AdminHeader";
import AdminTable from "../components/admin/AdminTable";
import AdminDetailsModal from "../components/admin/AdminDetailsModal";
import AdminCreateModal from "../components/admin/AdminCreateModal";
import AdminDeleteModal from "../components/admin/AdminDeleteModal";
import { updateAdmin } from "../services/admin.service";
import AdminEditModal from "../components/admin/AdminEditModal";
import { useToast } from "../context/ToastContext";

export default function Admins() {
  const { showToast } = useToast();
  const [data, setData] = useState({ data: [], last_page: 1, total: 0 });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const [selected, setSelected] = useState(null);
  const [openCreate, setOpenCreate] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [editTarget, setEditTarget] = useState(null);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      loadAdmins();
    }, 400);
    return () => clearTimeout(delayDebounceFn);
  }, [page, search]);

  async function loadAdmins() {
    setLoading(true);
    try {
      const params = { page, search };
      const res = await getAdmins(params);
      setData(res);
    } catch (err) {
      showToast("Erreur de chargement", "error");
    } finally {
      setLoading(false);
    }
  }

  async function handleCreate(payload) {
    try {
      await createAdmin(payload);
      showToast("Administrateur créé", "success");
      setOpenCreate(false);
      setPage(1);
      loadAdmins();
    } catch (err) {
      showToast("Erreur lors de la création", "error");
    }
  }

  async function handleEditSubmit(id, payload) {
    try {
      await updateAdmin(id, payload);
      showToast("Administrateur modifié", "success");
      setEditTarget(null);
      loadAdmins();
    } catch (err) {
      showToast("Erreur lors de la modification", "error");
    }
  }

  async function handleDelete(id) {
    try {
      await deleteAdmin(id);
      showToast("Administrateur supprimé", "success");
      setDeleteTarget(null);
      loadAdmins();
    } catch (err) {
      showToast("Erreur lors de la suppression", "error");
    }
  }

  if (loading && data.data.length === 0) {
    return (
      <div className="loaderContainer">Chargement des administrateurs...</div>
    );
  }

  return (
    <div className="page">
      <AdminHeader
        total={data.total}
        search={search}
        onSearch={(v) => {
          setSearch(v);
          setPage(1);
        }}
        onAdd={() => setOpenCreate(true)}
      />

      <div className={loading ? "tableContainer loading" : "tableContainer"}>
        <AdminTable
          admins={data.data}
          onView={setSelected}
          onEdit={setEditTarget}
          onDelete={setDeleteTarget}
        />
      </div>

      <div className="paginationContainer">
        <div className="pagiInfo">
          Page <strong>{page}</strong> sur {data.last_page}
        </div>
        <div className="pagiControls">
          <button
            className="pagiBtn"
            disabled={page === 1 || loading}
            onClick={() => setPage((p) => p - 1)}
          >
            Précédent
          </button>
          <button
            className="pagiBtn"
            disabled={page === data.last_page || loading}
            onClick={() => setPage((p) => p + 1)}
          >
            Suivant
          </button>
        </div>
      </div>

      {/* Modals */}
      <AdminCreateModal
        open={openCreate}
        onClose={() => setOpenCreate(false)}
        onSubmit={handleCreate}
      />
      <AdminEditModal
        open={!!editTarget}
        admin={editTarget}
        onClose={() => setEditTarget(null)}
        onSubmit={handleEditSubmit}
      />
      <AdminDetailsModal admin={selected} onClose={() => setSelected(null)} />
      <AdminDeleteModal
        admin={deleteTarget}
        onClose={() => setDeleteTarget(null)}
        onConfirm={handleDelete}
      />
    </div>
  );
}
